<template>
  <div v-bind:class="{full:true}">
    <div class="pc pcbg" v-bind:class="{on:isOn}"></div>
    <div class="content">
      <img src="../assets/pc_full.png" alt="" class="pc">
      <img src="../assets/sp_full.jpg" class="sp fullHead">
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullView',
  data: function(){
    return {
      isOn: false
    }
  },
  mounted: function(){
    this.isOn = true;
    var _this = this;
    setInterval(function(){
      _this.isOn = !_this.isOn;
    }, 32000);
  }
}
</script>

<style scoped>
.full{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
}
.pcbg{
  width: 120vw;
  height: 130vh;
  background: url(../assets/mainimage.jpg) bottom left no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  transition: background-position 30s linear,left 30s linear;
  position: absolute;
  left: -5vw;
  top: -15vh;
}
.pcbg.on{
  left: -20vw
}
.content{
  position: relative;
  width: 100%;
  height: 100%;
}
.content img.pc{
  max-width: 50vw;
  position: absolute;
  left: 18vw;
  top: 50%;
  transform: translateY(-50%);
}
.fullHead{
  width: 100%;
}
.sp{
  display: none;
}
@media screen and (max-width:1080px){
  h1{
   font-size: 60px; 
  }
}
@media screen and (max-height:780px){
  h1{
   font-size: 60px; 
  }
}
@media screen and (max-width:780px){
  h1{
   font-size: 40px; 
  }
}
@media screen and (max-height:580px){
  h1{
   font-size: 40px; 
  }
}
@media screen and (max-width:480px){
  .full{
    background: none;
    height: auto;
    padding-bottom: 0px;
  }
  .full:after{
    content: " ";
    display: block;
    height: 1px;
    background: #000;
    margin: 0 30px;
    padding: 0;
    margin-top: 50px;
    opacity: 0.6;
  }
  .sp{
    display: inline-block;
  }
  .pc{
    display: none;
  }
  h1{
    display: none;
  }
}
</style>
